export const getMcLarenValeData = () => ({
  name: "McLaren Vale",
  country: "Australie",
  description: "McLaren Vale est une région viticole prestigieuse d'Australie-Méridionale, réputée pour ses vins rouges puissants et ses blancs aromatiques. Son climat méditerranéen et ses sols variés créent des conditions idéales pour des vins de grande qualité.",
  type: "region",
  mapAreas: [
    { region: "McLaren Vale", x: 40, y: 80, color: "#a768a6", size: 4 }
  ],
  statistics: {
    totalArea: "7,000 ha",
    production: "0.5 million hectolitres",
    appellations: "McLaren Vale GI",
    subregions: "4 sous-régions principales",
    exportPercentage: "35%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influence océanique, étés chauds et secs, hivers doux",
    soil: "Sols très variés : argileux, calcaires, sableux, excellente diversité géologique",
    viticulture: "Viticulture moderne, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Shiraz puissants et fruités, Grenache élégants, assemblages complexes",
    white: "Chardonnay aromatiques, Sauvignon Blanc frais, Sémillon complexes",
    rose: "Rosés fruités et vifs, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à McLaren Vale remonte aux années 1830. La région s'est imposée comme l'une des plus prestigieuses d'Australie, reconnue pour ses vins rouges de qualité exceptionnelle et son innovation viticole.",
  foodPairing: "Cuisine australienne : barbecue, viandes rouges, fruits de mer, fromages affinés, cuisine fusion.",
  subregions: {
    "mclaren-vale": {
      name: "McLaren Vale",
      description: "Cœur de la région, réputé pour ses Shiraz puissants et ses assemblages complexes.",
      characteristics: {
        climate: "Méditerranéen, influence océanique",
        soil: "Sols argileux et calcaires",
        viticulture: "Vignobles historiques, rendements limités"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
        red: ["Shiraz", "Grenache", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "shiraz": "Rouges puissants et fruités",
        "grenache": "Rouges élégants et épicés"
      },
      foodPairing: "Viandes rouges, barbecue, fromages affinés"
    },
    "blewitt-springs": {
      name: "Blewitt Springs",
      description: "Zone de sables, connue pour ses vins rouges élégants et ses blancs frais.",
      characteristics: {
        climate: "Méditerranéen, influence océanique",
        soil: "Sols sableux, excellente drainage",
        viticulture: "Vignobles modernes, sols sableux"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc"],
        red: ["Shiraz", "Grenache", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "rouge": "Rouges élégants et fruités",
        "blanc": "Blancs frais et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, cuisine moderne"
    },
    "clarendon": {
      name: "Clarendon",
      description: "Zone d'altitude, réputée pour ses vins rouges structurés et ses blancs complexes.",
      characteristics: {
        climate: "Plus frais, altitude élevée",
        soil: "Sols argileux et granitiques",
        viticulture: "Vignobles modernes, altitude élevée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
        red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "rouge": "Rouges structurés et complexes",
        "blanc": "Blancs complexes et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, cuisine traditionnelle"
    },
    "willunga": {
      name: "Willunga",
      description: "Zone côtière, connue pour ses vins blancs frais et ses rouges fruités.",
      characteristics: {
        climate: "Méditerranéen, forte influence océanique",
        soil: "Sols sableux et argileux",
        viticulture: "Vignobles modernes, proximité de l'océan"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
        red: ["Shiraz", "Grenache", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "blanc": "Blancs frais et aromatiques",
        "rouge": "Rouges fruités et équilibrés"
      },
      foodPairing: "Fruits de mer, poissons, cuisine côtière"
    }
  }
}); 